/**
 * shop-collection-penny.js
 * Penny Swimwear — Shop Collection Page
 *
 * Provides staggered fade-in animation for product cards
 * using IntersectionObserver. When a product grid enters
 * the viewport, each card fades in sequentially with a
 * per-card delay for a cascading effect.
 *
 * The animation respects the user's prefers-reduced-motion
 * setting — if enabled, cards appear immediately without
 * animation (handled via CSS media query).
 *
 * Dependencies: None (vanilla JS, no jQuery required)
 * Loaded via: <script defer> in shop-collection-penny.liquid
 */

(function () {
  'use strict';

  function init() {
    var grids = document.querySelectorAll('.shop-collection-penny__grid[data-animate="true"]');

    if (!grids || grids.length === 0) {
      return;
    }

    grids.forEach(function (grid) {
      var cards = grid.querySelectorAll('.shop-collection-penny__card');

      if (!cards || cards.length === 0) {
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var index = parseInt(entry.target.getAttribute('data-index') || '0', 10);
            entry.target.style.transitionDelay = (index % 8) * 80 + 'ms';
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px'
      });

      cards.forEach(function (card) {
        observer.observe(card);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
